/* Extracted from snippets/product-blocks.liquid on 2026-09-21.
   That snippet is rendered three times per product page (desktop-left, right, and a third
   pass) and these scripts sat at its top level, so every page carried three byte-identical
   copies. They are now loaded once as an asset. The logic is unchanged. */
document.addEventListener('DOMContentLoaded', function () {
    const variantSelect = document.getElementById('variant-select'); // Wilson Recommended
    const ownVariantSelect = document.getElementById('variant-select-own'); // Choose Your Own
    const submitButton = document.getElementById('submit-string-selection'); // Wilson Recommended Submit
    const ownSubmitButton = document.getElementById('submit-own-selection'); // Choose Your Own Submit
    const deleteButton = document.getElementById('delete-string-selection'); // Delete Button
    const selectedStringInfo = document.getElementById('selected-string-info'); // Section to show selected string info
    const displaySelectedVariant = document.getElementById('display-selected-variant'); // Area to display selected variant

    // product-blocks.liquid renders once per column, and only the column that holds the
    // variant picker also renders the string popup. If the popup isn't in THIS render,
    // bail out BEFORE claiming the guard flag — otherwise an early column without the popup
    // would grab the guard (and crash on the null buttons), and the later column that
    // actually has the popup gets skipped, so the buttons never get wired and the
    // selected-string info never appears.
    if (!submitButton || !ownSubmitButton || !deleteButton) return;

    // Popup is present — now guard against double-initialisation (an extra render would
    // otherwise attach another listener and add the string service twice).
    if (window._stringPopupInitialized) { console.log('[strings] already initialised, skipping'); return; }
    window._stringPopupInitialized = true;
    console.log('[strings] wiring up submit/delete handlers');

    // Stencil Checkboxes and Text
    const stencilCheckboxWilson = document.getElementById('stencil-included-wilson');
    const stencilCheckboxOwn = document.getElementById('stencil-included-own');
    const stencilTextWilson = document.getElementById('stencil-text-recommended');
    const stencilTextOwn = document.getElementById('stencil-text-own');

    // Handle Button Click for "Wilson Recommended"
    submitButton.addEventListener('click', function () {
        handleSelection(variantSelect, 'wilson');
    });

    // Handle Button Click for "Choose Your Own"
    ownSubmitButton.addEventListener('click', function () {
        handleSelection(ownVariantSelect, 'own');
    });

    // Function to handle selection
    function handleSelection(selectElement, type) {
        console.log('[strings] Add Strings clicked, type =', type, 'select =', selectElement);
        if (!selectElement) { console.warn('[strings] no select element'); return; }
        const selectedOption = selectElement.options[selectElement.selectedIndex];
        console.log('[strings] selectedIndex =', selectElement.selectedIndex, 'option =', selectedOption, 'value =', selectedOption && selectedOption.value);
        if (selectedOption && selectedOption.value) {
            const variantId = parseInt(selectedOption.value, 10);
            const variantTitle = selectedOption.textContent;

            let tennisMains, tennisCrosses, stencilIncluded, stencilText;

            if (type === 'wilson') {
                // Use the existing Tennis Mains and Crosses for Wilson Recommended
                tennisMains = document.getElementById('tennis-mains').textContent || 'Not Specified';
                tennisCrosses = document.getElementById('tennis-crosses').textContent || 'Not Specified';

                // Get stencil checkbox status and text for Wilson Recommended
                stencilIncluded = stencilCheckboxWilson.checked ? 'Yes' : 'No';
                stencilText = stencilCheckboxWilson.checked ? stencilTextWilson.textContent : 'N/A';
            } else if (type === 'own') {
                // For Choose Your Own, use custom inputs or selected options
                tennisMains = document.querySelector('select#select-mains-own').value || 'Not Specified';
                tennisCrosses = document.querySelector('select#select-crosses-own').value || 'Not Specified';

                // Get stencil checkbox status and text for Choose Your Own
                stencilIncluded = stencilCheckboxOwn.checked ? 'Yes' : 'No';
                stencilText = stencilCheckboxOwn.checked ? stencilTextOwn.textContent : 'N/A';
            }

            // Display selected values on the product page
            displaySelectedVariant.innerHTML = `
                <p><strong class="selected-strings">Selected Variant:</strong> ${variantTitle}</p>
                <p><strong class="selected-strings">Tension Mains:</strong> ${tennisMains}</p>
                <p><strong class="selected-strings">Tension Crosses:</strong> ${tennisCrosses}</p>
                <p><strong class="selected-strings">Brand Stencil:</strong> ${stencilIncluded}</p>
                <p><strong class="selected-strings">Stencil Text:</strong> ${stencilText}</p>
            `;

            // Show the selected string info section
            selectedStringInfo.style.display = 'block';

            // Build the properties object once
            const properties = {
                'Tension Mains': tennisMains,
                'Tension Crosses': tennisCrosses,
                'Brand Stencil': stencilIncluded,
                'Stencil Text': stencilText,
            };

            // Set the string service to exactly quantity 1. /cart/add.js increments the
            // quantity if the variant is already in the cart, so check the cart first and
            // use /cart/change.js to set qty=1 when it's already there.
            fetch('/cart.js')
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                    var existing = cart.items.find(function (item) {
                        return item.variant_id === variantId;
                    });

                    if (existing) {
                        // Already in cart — update to exactly qty 1
                        return fetch('/cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                            body: JSON.stringify({ id: existing.key, quantity: 1, properties: properties }),
                        }).then(function (r) { return r.json(); });
                    } else {
                        // Not in cart yet — add once
                        return fetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                            body: JSON.stringify({ id: variantId, quantity: 1, properties: properties }),
                        }).then(function (r) { return r.json(); });
                    }
                })
                .then(function (data) { console.log('String service cart updated:', data); })
                .catch(function (error) { console.error('Error updating cart:', error); });

            // Close the modal after the selection
            document.getElementById('price-request-modal').style.display = 'none';
        }
    }

    // Handle Delete Button Click
    deleteButton.addEventListener('click', function () {
        // Clear the displayed selected variant
        displaySelectedVariant.innerHTML = '';

        // Hide the selected string info section
        selectedStringInfo.style.display = 'none';

        // Optionally, reset both variant selects
        variantSelect.selectedIndex = 0;
        ownVariantSelect.selectedIndex = 0;
    });
});
